import L from 'leaflet'
import 'leaflet-routing-machine'

export default {
  state: {
    routingControl: new L.Routing.Control({
      showAlternatives: false,
      fitSelectedRoutes: true,
      createMarker: (i, wp, nWps) => {
        return L.marker([0, 0], {
          icon: L.ExtraMarkers.icon({
            icon: 'fa-location-arrow',
            markerColor: 'black',
            prefix: 'fa'
          })
        })
      },
      lineOptions: {
        addWaypoints: false
      },
      router: L.Routing.mapbox('pk.eyJ1IjoiZ29tb25rZXlhbWFuZ28iLCJhIjoiY2pneHgwOTNtMXA1eTMzcGd1eHVtMXYxeiJ9.ERQfx8U8kHKB8adxfGkMGA', {
        profile: 'mapbox/driving'
      }),
      formatter: new L.Routing.Formatter({
        units: 'imperial'
      })
    }),
    itinerary: null,
    vehicle: 'driving',
    stops: [],
    triggerValidation: false
  },
  getters: {
    routingControl: state => state.routingControl,
    itinerary: state => state.itinerary,
    vehicle: state => state.vehicle,
    stops: state => state.stops,
    triggerValidation: state => state.triggerValidation
  },
  mutations: {
    setRoutingControl (state, data) {
      state.routingControl = data
    },
    setItinerary (state, data) {
      state.itinerary = data
    },
    setVehicle (state, data) {
      state.vehicle = data
      state.routingControl.getRouter().options.profile = `mapbox/${data}`
    },
    setStops (state, data) {
      state.stops = data
    },
    setTriggerValidation (state, data) {
      state.triggerValidation = data
    }
  },
  actions: {
    addStop ({ commit, state }, { index, stop }) {
      const stops = [...state.stops]
      stops.splice(index + 1, 0, stop)
      commit('setStops', stops)
    },
    removeStop ({ commit, state }, index) {
      const stops = [...state.stops]
      stops.splice(index, 1)
      commit('setStops', stops)
    }
  }
}
